var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-1 items-center justify-center"},[_c('Transition',{attrs:{"appear":""}},[_c('font-awesome-icon',{staticClass:"text-6xl text-gray-500",attrs:{"icon":['fas', 'spinner'],"spin":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }